import Vue from 'vue';
import store from './../../store';
import orderTransformer from './../../transformers/order';

const success = ({ data }, resolve) => {
  const orders = orderTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllOrders', orders);
  resolve(orders);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/orders')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/all.js